import type { User } from 'firebase/auth';

const API_BASE = (import.meta.env.REACT_APP_API_URL || '/api/v1').replace(/\/$/, '');

export async function createBrowserAuthSession(user: User): Promise<void> {
  const token = await user.getIdToken();
  const response = await fetch(`${API_BASE}/auth/validate-token`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
      'X-Platform': 'web',
    },
    body: JSON.stringify({ token }),
  });

  if (!response.ok) {
    throw new Error('Failed to establish the required Taskora authentication session');
  }
}

export async function revokeBrowserAuthSession(user: User): Promise<void> {
  const token = await user.getIdToken();
  const response = await fetch(`${API_BASE}/auth/sessions/current`, {
    method: 'DELETE',
    credentials: 'include',
    headers: {
      Authorization: `Bearer ${token}`,
      'X-Platform': 'web',
    },
  });
  if (!response.ok) {
    throw new Error('Failed to revoke the current Taskora authentication session');
  }
}

export async function createSocketAuthTicket(user: User): Promise<string> {
  const token = await user.getIdToken();
  const response = await fetch(`${API_BASE}/auth/socket-ticket`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      Authorization: `Bearer ${token}`,
      'X-Platform': 'web',
    },
  });
  if (!response.ok) {
    throw new Error('Failed to create a socket authentication ticket');
  }
  const payload = (await response.json()) as { data?: { ticket?: string } };
  if (!payload.data?.ticket) {
    throw new Error('Socket authentication ticket response is invalid');
  }
  return payload.data.ticket;
}
